module.exports = __webpack_public_path__ + "static/data-structures-and-algorithms-course-8c5059a1d3ffa2e8fe4b6f3610512323.svg";